import { useQuery } from "@tanstack/react-query";
import { fetchQuoteFreshness, type FreshnessParams } from "../api/client.ts";

const POLL_MS = 15_000;

// Thin fetch+poll hook. The chip ticks the age forward locally between polls
// (anchored on dataUpdatedAt to stay clock-skew-safe), so this stays a plain
// data hook keyed on the market.
export function useQuoteFreshness(p: FreshnessParams) {
  return useQuery({
    queryKey: ["quote-freshness", p.clientId, p.venue, p.pair],
    queryFn: () => fetchQuoteFreshness(p),
    refetchInterval: POLL_MS,
    staleTime: POLL_MS,
  });
}
